import { Components } from '.generated/templates/Feature.Components.model';
import { Core } from '.generated/templates/Foundation.Core.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { Item, Field, LinkField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { propsFromFields } from '../Heading';
import { getPageCtaText } from 'lib/util/text-fallback';
import { classnames } from 'tailwindcss-classnames';
import { OnLinkDataLayerPush } from 'lib/util/gtm-datalayer';
import { GenericFieldValue } from '@sitecore-jss/sitecore-jss/types/layout/models';

export interface PageCardProps {
  promotedPage: Sitecore.Override.ItemEx & Core.BaseTemplates.Routes.Fields.BasePage;
  pageCard?: Components.General.PageCard.Fields.PageCard;
  isSingleCard: boolean;
  onGtmPush?: OnLinkDataLayerPush;
}

export const getLinkAndHeaderProps = (props: PageCardProps, editable = true) => {
  const { promotedPage, pageCard } = props;
  const linkField: LinkField = {
    value: {
      href: promotedPage.url,
      text: pageCard?.fields?.ctaTextOverride?.value || getPageCtaText(promotedPage),
    },
  };

  const headingProps = propsFromFields({
    headingText: promotedPage.fields.pageTitle,
    headingTextOverride: pageCard?.fields?.titleOverride,
    description: promotedPage.fields.pageDescription,
    descriptionOverride: pageCard?.fields?.descriptionOverride,
    editable,
  });

  return { linkField, headingProps };
};

export const getCardTopBorderClass = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const sitecoreContext = useSitecoreContext();
  const isRitn = sitecoreContext.sitecoreContext.RITN ?? false;

  return classnames(
    'cc-border-top',
    { 'cc-border-top-blue-navy': isRitn },
    { 'cc-border-top-blue': !isRitn }
  );
};

export const getFeaturedImageCaption = (
  featuredImageCaption: Item | Field<GenericFieldValue> | Item[] | undefined
): Field<string> | undefined => {
  function isFieldString(field: unknown): field is Field<string> {
    return !!field && typeof (field as Field<string>).value === 'string';
  }
  return isFieldString(featuredImageCaption) ? featuredImageCaption : undefined;
};
